import { render, staticRenderFns } from "./BidDashboardBoard.vue?vue&type=template&id=1b410a44&scoped=true"
import script from "./BidDashboardBoard.vue?vue&type=script&lang=js"
export * from "./BidDashboardBoard.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardBoard.vue?vue&type=style&index=0&id=1b410a44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b410a44",
  null
  
)

export default component.exports